import React from 'react'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

import Icon from '@/icons'
import './styles.css'

const SectionRevenueImg = ({ sizes, icon, iconText, number, numberText }) => {
  return (
    <div className="w-100 w-50-m w-25-l ph3 mb4 mb0-l">
      <div className="mw186 center">
        <Img sizes={sizes} alt="" className="mb4" />

        <div className="mb2 pa2 w96 min-h96 ba b--moon-gray br2 center flex flex-column items-center justify-center">
          <Icon icon={icon} size="36px" className="mb2" />
          <p className="mv0 f13 tc">{iconText}</p>
        </div>

        {!!number && (
          <div className="flex">
            <div className="mr2 flex-shrink-0 w50 h50 bg-black white pa2 br-100 flex items-center justify-center">
              {number}
            </div>

            <p className="mv0 f13 mv1">{numberText}</p>
          </div>
        )}
      </div>
    </div>
  )
}

SectionRevenueImg.propTypes = {
  sizes: PropTypes.object
}

export default SectionRevenueImg



// WEBPACK FOOTER //
// ./src/components/section-revenue/section-revenue-img.js